import { AlertStyled } from "@/components/AlertStyled";
import { ContentContainer } from "@/components/ContentContainer";
import TextFieldStyled from "@/components/TextFieldStyled";
import {forgotPassword} from "@/lib/api";
import theme from "@/styles/theme";
import { Button, Grid, Typography } from "@mui/material";
import {  useEffect, useState } from "react";

const ForgotPassword = () => {
  const DEFAULT_VALUES = {
    email: "",
  };
  const [formValues, setFormValues] = useState(DEFAULT_VALUES);
  const [formValid, setFormValid] = useState(false);
  const [ success, setSuccess ] = useState(false);
  const [ error, setError ] = useState(null);

  useEffect(() => {
    setFormValid(
      formValues.email.length > 2
    );
  }, [formValues]);

  const handleInputChanged = (event) => {
    const {name, value} = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setError(null);
    setSuccess(false);

    forgotPassword(formValues.email)
      .then(() => {
        setFormValues(DEFAULT_VALUES);
        setSuccess(true)
      })
      .catch((error) => {
        setError("Es ist ein Fehler aufgetreten. Bitte prüfe, ob Du die richtige E-Mail Adresse angegeben hast.")
    });

  };

  return (
    <ContentContainer headline="Passwort vergessen?">
      <Grid container justifyContent="center">
        <Grid item xs={10}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  component="p"
                  sx={{
                    mt: 4,
                    mb: 1,
                    "&.MuiTypography-root": {
                      color: theme.palette.common.black,
                    },
                  }}
                >
                  Brauchst du Hilfe mit deinem Passwort?
                </Typography>
                <Typography variant="body1">
                  Gib deine E-Mail-Adresse ein und wir helfen dir ein neues
                  Passwort festzulegen.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextFieldStyled
                  required={true}
                  type="email"
                  label="E-Mail Adresse"
                  name="email"
                  value={formValues.email}
                  onChange={handleInputChanged}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  color="secondary"
                  type="submit"
                  disabled={!formValid}
                >
                  Passwort zurücksetzen
                </Button>
              </Grid>
              {success &&
                  <Grid item xs={12}>
                    <AlertStyled
                        severity="success"
                        text="Ein Link zum zurücksetzen deines Passwortes wurde an deine Emailadresse gesendet und sollte innerhalb von 5 Minuten bei dir eintreffen. Schau auch mal im Spamordner nach."
                    />
                  </Grid>
              }
              {error &&
                <Grid item xs={12}>
                  <AlertStyled
                    severity="error"
                    text={error}
                  />
                </Grid>
              }
            </Grid>
          </form>
        </Grid>
      </Grid>
    </ContentContainer>
  );
};

export default ForgotPassword;
